<div class="pr-small-t block mr-large-b rounded-large border white-bg" *ngIf="booking$ | async as booking">
  <h2 class="pr-small-x pr-small-b font-heading-4 nordic-blue-900-text">
    {{ 'MMB.modifyYourTrip.title' | finLocalization }}
  </h2>
  <div class="dn-mobile db-tablet-up">
    <div *ngIf="showTravelExtrasButton" class="flex flex--center flex--space-between pr-small-x pr-small-b">
      <span class="flex-1 flex--basis0 medium-type font-body-1">{{
        'MMB.modifyYourTrip.labels.addComfortToYourTravel' | finLocalization
      }}</span>
      <fcom-button
        data-testid="modify-add-extras-button"
        class="flex-1 flex--basis0"
        [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
        [mode]="ButtonMode.FILL"
        [text]="'MMB.modifyYourTrip.labels.addExtras' | finLocalization"
        (clickBtn)="scrollToTravelExtrasContent()"
      ></fcom-button>
    </div>
    <ng-container *ngIf="changeableBoundIds$ | async as changeableBoundIds">
      <div *ngIf="changeableBoundIds.length > 0" [class.border-top]="showTravelExtrasButton">
        <div
          [class.pr-small-t]="showTravelExtrasButton"
          class="flex flex--center flex--space-between pr-small-x pr-small-b"
        >
          <span class="flex-1 flex--basis0 medium-type font-body-1">{{
            'MMB.modifyYourTrip.labels.changeOfPlans' | finLocalization
          }}</span>

          <fcom-button
            class="flex-1 flex--basis0"
            [icon]="null"
            [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
            [mode]="ButtonMode.FILL"
            [text]="'MMB.labels.changeFlight' | finLocalization"
            (clickBtn)="changeFlight(booking, changeableBoundIds)"
          ></fcom-button>
        </div>
      </div>
    </ng-container>
    <div *ngIf="showCancelButton$ | async" class="border-top">
      <div class="flex flex--center flex--space-between pr-small">
        <span class="flex-1 flex--basis0 medium-type font-body-1">{{
          'MMB.modifyYourTrip.labels.unableToTravel' | finLocalization
        }}</span>
        <div class="flex-1 flex--basis0">
          <fcom-button
            data-testid="modify-cancel-button"
            [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
            [mode]="ButtonMode.FILL"
            [text]="'MMB.labels.cancelFlights' | finLocalization"
            (clickBtn)="openCancelBookingModal(booking)"
          ></fcom-button>
        </div>
      </div>
    </div>
    <ng-container *ngIf="modificationNotAllowedNotifications$ | async as modificationNotAllowedNotifications">
      <div *ngIf="modificationNotAllowedNotifications.length > 0" class="pr-small-x pr-small-b">
        <fin-mmb-notifications
          class="flex-1 flex--basis0 nordic-blue-900-text light-type"
          [notifications]="modificationNotAllowedNotifications"
        ></fin-mmb-notifications>
      </div>
    </ng-container>
  </div>
  <div class="db-mobile dn-mobile-up">
    <div *ngIf="showTravelExtrasButton" class="pr-small-x pr-small-b">
      <span class="medium-type font-body-1">{{
        'MMB.modifyYourTrip.labels.addComfortToYourTravel' | finLocalization
      }}</span>
      <fcom-button
        data-testid="modify-add-extras-button"
        class="pr-small-t"
        [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
        [mode]="ButtonMode.FILL"
        [text]="'MMB.modifyYourTrip.labels.addExtras' | finLocalization"
        (clickBtn)="scrollToTravelExtrasContent()"
      ></fcom-button>
    </div>
    <ng-container *ngIf="changeableBoundIds$ | async as changeableBoundIds">
      <div *ngIf="changeableBoundIds.length > 0" class="pr-small-x pr-small-b">
        <span class="medium-type font-body-1">{{ 'MMB.modifyYourTrip.labels.changeOfPlans' | finLocalization }}</span>
        <fcom-button
          class="pr-small-t"
          [icon]="null"
          [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
          [mode]="ButtonMode.FILL"
          [text]="'MMB.labels.changeFlight' | finLocalization"
          (clickBtn)="changeFlight(booking, changeableBoundIds)"
        ></fcom-button>
      </div>
    </ng-container>
    <div *ngIf="showCancelButton$ | async" class="pr-small-x pr-small-b">
      <span class="medium-type font-body-1">{{ 'MMB.modifyYourTrip.labels.unableToTravel' | finLocalization }}</span>
      <fcom-button
        data-testid="modify-cancel-button"
        class="pr-small-t"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [mode]="ButtonMode.FILL"
        [text]="'MMB.labels.cancelFlights' | finLocalization"
        (clickBtn)="openCancelBookingModal(booking)"
      ></fcom-button>
    </div>
    <ng-container *ngIf="modificationNotAllowedNotifications$ | async as modificationNotAllowedNotifications">
      <div *ngIf="modificationNotAllowedNotifications.length > 0" class="pr-small-x pr-small-b">
        <fin-mmb-notifications
          class="nordic-blue-900-text light-type pr-medium-b"
          [notifications]="modificationNotAllowedNotifications"
        ></fin-mmb-notifications>
      </div>
    </ng-container>
  </div>
</div>

<fin-mmb-change-flight-general-info-modal
  [isOpen]="changeFlightModalOpen$ | async"
  [booking$]="booking$"
  (modalClosed)="changeFlightModalOpen$.next(false)"
></fin-mmb-change-flight-general-info-modal>

<fin-cancel-booking-modal
  *ngIf="showCancelButton$ | async"
  [booking]="booking$ | async"
  [isOpen]="cancelModalOpen$ | async"
  (modalClosed)="cancelModalOpen$.next(false)"
></fin-cancel-booking-modal>
